exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Answers{margin-top:10px}.Answers .title{font-weight:700;font-size:20px;line-height:26px;color:#202122;margin-bottom:10px}.Answers .text{margin-bottom:10px;font-size:16px;color:#979797}.Answers .items{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:wrap}.Answers .itemCreate{margin-left:15px;margin-right:15px;width:200px;height:50px;border-radius:0;border:1px solid #17a05d;margin-bottom:10px;display:flex;align-items:center;flex-direction:column;justify-content:center;cursor:pointer}.Answers .itemCreate img{max-width:100%;max-height:100%}.Answers .itemCreate .text{margin-bottom:0;color:#98a1b3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/style.module.scss
// module id = 4860
// module chunks = 0